// Swaps in a neutral placeholder the instant any <img> in the app fails to
// load (dead CDN link, null avatar URL, offline network) instead of letting
// the browser show its ugly broken-image icon. One listener covers every
// image everywhere — current pages and anything rendered later — so no
// component has to remember to handle this itself.
const FALLBACK_SRC =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <rect width="100" height="100" fill="#2a2a24"/>
      <circle cx="50" cy="38" r="18" fill="#5c5c4f"/>
      <path d="M50 60c-19 0-32 11-32 26v6c0 4 3 8 8 8h48c5 0 8-4 8-8v-6c0-15-13-26-32-26z" fill="#5c5c4f"/>
    </svg>`,
  );

export function installGlobalImageFallback() {
  document.addEventListener(
    "error",
    (event) => {
      const el = event.target;
      if (
        el instanceof HTMLImageElement &&
        !el.dataset.fallbackApplied &&
        el.src !== FALLBACK_SRC
      ) {
        el.dataset.fallbackApplied = "true";
        el.src = FALLBACK_SRC;
      }
    },
    true, // capture phase — the "error" event on <img> doesn't bubble
  );
}
